var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"tw-border tw-border-white tw-rounded-full tw-object-contain tw-text-xxs",class:{
    'tw-h-10 tw-w-10': _vm.size === 'base',
    'tw-h-8 tw-w-8': _vm.size === 'sm',
    'tw-h-12 tw-w-12': _vm.size === 'lg',
    'tw-h-4 tw-w-4': _vm.size === 'xxs',
  },attrs:{"alt":_vm.fullName,"aria-label":`${_vm.fullName} avatar`,"title":_vm.fullName,"data-blink-src":_vm.avatarUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }